import { useLexicalComposerContext } from "@lexical/react/LexicalComposerContext";
import { useCallback } from "react";

import type { LexicalNode } from "lexical";

export const useGetElementRect = (): ((node: LexicalNode) => DOMRect | null) => {
  const [editor] = useLexicalComposerContext();

  return useCallback(
    (node: LexicalNode): DOMRect | null => {
      const element = editor.getElementByKey(node.getKey());
      if (element) {
        return element.getBoundingClientRect();
      }
      return null;
    },
    [editor],
  );
};
